module.exports = __webpack_public_path__ + "img/browse-vehicles-background-honda.24782ed7.png";